import api from "../axiosInstance";

export const getNotifications = async (payload) => {
  try {
    const response = await api.get(`/notifications`);
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const readAllNotifications = async (payload) => {
  try {
    const response = await api.put(`/notifications/read`);
    return response;
  } catch (err) {
    throw err;
  }
};
